import {Ability} from '@casl/ability'

let ability = new Ability();


export { ability };
